import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, LOCALE_ID, OnInit, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { LocalStorageService } from 'src/app/kernel/tools/services/local-storage.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { ELocalizationLang } from 'src/app/shared/enums/localizationLang.enum';
import {AuthService} from "../../../../core/services/auth.service";

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss'],

})
export class TopNavComponent implements OnInit {

  router = inject(Router);
  authService = inject(AuthService);
  langService = inject(LanguageService);
  localStorage = inject(LocalStorageService);
  currentLang = inject(LOCALE_ID) as ELocalizationLang;

  showMenu: boolean = false;
  companyId = '';
  lang: ELocalizationLang = ELocalizationLang.EN;
  // token = this.authService.getToken();

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.lang = this.currentLang


  }


  @ViewChild("userMenu") userMenu!: ElementRef;
  @ViewChild("userMenuIcon") userMenuIcon!: ElementRef;

  ngOnInit() { }

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  logout(){
    this.authService.logout();
  }

  navigateIntoCompanyProfile(){
    this.companyId = (this.localStorage.get('user') as any)?.employeeOrigin?.company?.id;
    this.router.navigateByUrl(`/dashboard/profile/${this.companyId}`);
  }

  // navigateIntoProfile(){
  //   const employeeId = (this.localStorage.get('user') as IUser)?.employeeOrigin?.id;
  //   this.router.navigateByUrl(`/dashboard/employees/view/${employeeId}`);
  // }


  toggleLang() {
    this.lang = this.lang === ELocalizationLang.EN ? ELocalizationLang.AR : ELocalizationLang.EN;

    // this.authService.setMyPreferedLang(this.lang).pipe(
    //   finalize(() => {
    //     this.langService.changeLang(this.lang);
    //   })
    // ).subscribe()
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: Event) {
    const clickedInsideMenu = this.userMenu?.nativeElement.contains(event.target);
    const clickedToggleButton = this.userMenuIcon?.nativeElement.contains(event.target);
    if (!clickedInsideMenu && !clickedToggleButton && this.showMenu) {
      this.showMenu = false;
    }
  }
}


